// 构建时由 vite.config.js 从 CHANGELOG.md 写入；预览等没有注入的环境显示为空
export const APP_VERSION = typeof __APP_VERSION__ === 'undefined' ? '' : __APP_VERSION__
